// extracted by mini-css-extract-plugin
module.exports = {"logo":"index_logo_11PiT"};